"use client";

import MediumLeftVector from "@/helpers/mediumLeftVector";
import MediumRightVector from "@/helpers/mediumRightVector";
import OnlineBakhishIcon from "@/helpers/svg/onlineBakhishIcon.svg";
import React, { useRef, useState } from "react";
import CustomButton from "../common/button";
import TagIcon from "@/helpers/svg/tagIcon.svg";
import HeartIcon from "@/helpers/svg/heartIcon.svg";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import LeftArrowIcon from "@/helpers/svg/leftArrowIcon.svg";
import OnlineBakhishIconMini from "@/helpers/svg/onlineBakhishIconMini.svg";
import Link from "next/link";
import ImdbIcon from "@/helpers/svg/imdbIcon.svg";
import { EffectCreative, EffectFade } from "swiper/modules";
import { getCMSImageURL } from "@/helpers/CMSImageURL";
import { Chip } from "@nextui-org/react";
import { ROUTES } from "@/routes/appRoutes";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/effect-creative";
import useWindowSize from "@/helpers/hooks/useWindowSize";
import { useRouter } from "next/navigation";

const OnlineBakhish = ({ items }) => {
  const [clickedIndex, setClickedIndex] = useState(0);
  const bigSwiper = useRef();
  const smallSwiper = useRef();
  const device = useWindowSize();
  const router = useRouter();

  if (!items || items?.length < 1) return;

  return (
    <div className="flex flex-col mx-auto">
      <div
        className="flex text-3xl px-4 text-shadow text-primary-white justify-center items-center pb-4"
        onClick={() => router.push(ROUTES.online_bakhish)}
      >
        <div className="hidden md:block w-[39%] ml-4">
          <img src="/onlineBakhish-dot.png" className="w-full" />
        </div>
        <div className="hidden sm:block">
          <OnlineBakhishIcon />
        </div>
        <div className="block sm:hidden">
          <OnlineBakhishIconMini />
        </div>
        <div className="flex justfiy-center items-center sm:w-[205px]">
          <span className="mx-1 md:mx-3 text-xl sm:text-3xl w-full sm:w-[161px]">
            آنلاین باخیش
          </span>
          <div className="hidden md:block">
            <LeftArrowIcon />
          </div>
        </div>
        <div className="hidden md:block w-[39%] mr-4">
          <img src="/onlineBakhish-dot.png" className="w-full" />
        </div>
      </div>
      <div className="flex flex-row left-0 right-0 z-9999 m-0 justify-between md:mx-4">
        <div className="hidden xl:flex xl:w-[25%] h-[496px] ml-[10px]">
          <div className="relative right-2 bottom-[5px] z-10">
            <MediumRightVector />
          </div>
          <Swiper
            id="onlinebakhish-main"
            itemID="onlinebakhish-main-item"
            className="max-w-full w-full relative bg-[#262626] h-[496px] cursor-pointer"
            direction="vertical"
            modules={[Navigation, Autoplay]}
            autoplay={{ delay: 10000, disableOnInteraction: true }}
            speed={1000}
            slidesPerView={3}
            spaceBetween={8}
            slideToClickedSlide
            onSwiper={(swiper) => (smallSwiper.current = swiper)}
            navigation={{
              nextEl: "#onlinebakhish-main .swiper-button-next",
              prevEl: "#onlinebakhish-main .swiper-button-prev",
            }}
            onSlideChange={(swiper) => {
              setClickedIndex(swiper.realIndex);
              bigSwiper?.current?.slideTo(swiper.realIndex);
            }}
          >
            {items?.map(({ content, sliderType }, index) => {
              const { contentPhotos } = content;
              return (
                <SwiperSlide
                  key={"main-item" + sliderType + index}
                  style={{
                    backgroundImage: `url(${getCMSImageURL(
                      contentPhotos.find(
                        (x) =>
                          x.type === "onlineBakhishCover" && device === device
                      )?.src ||
                        contentPhotos.find(
                          (x) => x.type === "onlineBakhishCover"
                        )?.src ||
                        contentPhotos.find(
                          (x) =>
                            x.type === "horizontalCover" && device === device
                        )?.src ||
                        contentPhotos.find((x) => x.type === "horizontalCover")
                          ?.src
                    )})`,
                    backgroundSize: "cover",
                    backgroundPosition: "left center",
                    backgroundRepeat: "no-repeat",
                  }}
                  onClick={() => {
                    setClickedIndex(index);
                    bigSwiper?.current?.slideTo(index);
                  }}
                  className={`${
                    clickedIndex === index && "!grayscale-0"
                  } !flex aspect-[16/9] h-full !justify-start bg-contain !items-center grayscale`}
                ></SwiperSlide>
              );
            })}
            <div className="absolute top-0 left-0 right-0 flex justify-center items-center z-20">
              <div
                className="swiper-button-prev relative !w-22 !h-22 !text-primary-white"
                style={{
                  position: "relative",
                  transform: "rotate(270deg)",
                  marginTop: "1rem",
                }}
              ></div>
            </div>
            <div className="absolute bottom-0 left-0 right-0 flex justify-center items-center !z-20">
              <div
                className="swiper-button-next !text-primary-white absolute bottom-0 left-0"
                style={{
                  position: "relative",
                  transform: "rotate(270deg)",
                  marginBottom: "1rem",
                }}
              ></div>
            </div>
          </Swiper>
          <div className="relative left-2 bottom-[5px] z-10">
            <MediumLeftVector />
          </div>
        </div>
        <div className="hidden xl:flex w-full xl:max-w-[75%] xl:!min-w-[75%] h-[496px] ">
          <div className="relative right-2 bottom-[5px] z-10">
            <MediumRightVector />
          </div>
          <div className="flex bg-[#262626] w-full h-[496px] min-w-[500px] py-2">
            <Swiper
              id="onlinebakhish-main-scene"
              className="max-w-full w-full relative bg-[#262626] h-[481px]"
              speed={750}
              slidesPerView={1}
              modules={[EffectFade]}
              effect="fade"
              draggable={false}
              allowTouchMove={false}
              onInit={(swiper) => (bigSwiper.current = swiper)}
              centerInsufficientSlides
              loopAdditionalSlides={5}
            >
              {items?.map(({ content }, index) => {
                const { contentPhotos, title, slug } = content;
                return (
                  <SwiperSlide
                    key={"onlinebakhish-main-scene" + index}
                    style={{
                      backgroundImage: `url(${getCMSImageURL(
                        contentPhotos.find(
                          (x) =>
                            x.type === "onlineBakhishCover" && device === device
                        )?.src ||
                          contentPhotos.find(
                            (x) => x.type === "onlineBakhishCover"
                          )?.src ||
                          contentPhotos.find(
                            (x) =>
                              x.type === "horizontalCover" && device === device
                          )?.src ||
                          contentPhotos.find(
                            (x) => x.type === "horizontalCover"
                          )?.src
                      )})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                    }}
                    className={`${
                      clickedIndex === index && "!grayscale-0"
                    } !flex aspect-[16/7] h-full !justify-start bg-contain !items-end grayscale`}
                  >
                    <div className="flex absolute top-0 bottom-0 left-0 right-0 items-end justify-center">
                      <img
                        src="/online-bakhish-shadow.png"
                        className="w-full mb-[-10px]"
                      />
                    </div>

                    <div className="flex justify-between items-center pb-3 w-full px-4">
                      <div className="mr-4 pb-3 flex w-full lg:w-1/2 justify-between lg:justify-start items-center">
                        <span className="text-primary-white font-bold text-lg xl:text-[21.5px] 2xl:text-2xl ml-6 truncate w-[unset] z-10">
                          {title}
                        </span>
                        <Link href={`/movie/${slug}`}>
                          <CustomButton
                            label="سالن تماشا"
                            textColor="text-primary-white"
                            color="primary"
                            rightIcon={<TagIcon />}
                          />
                        </Link>
                      </div>
                      <div className="hidden w-full ml-3 pb-3 lg:flex justify-end items-center md:w-[260px] z-10 gap-5">
                        <div className="flex gap-1">
                          {content?.genreInfo?.map((genre, genreIndex) => {
                            return (
                              <Chip
                                size="sm"
                                key={"desktop_genre_" + genreIndex}
                              >
                                {genre.name}
                              </Chip>
                            );
                          })}
                        </div>
                        {content?.imdbRate ? (
                          <div className="text-primary-white flex items-center">
                            <span className="ml-1">{content?.rate}</span>
                            <HeartIcon />
                          </div>
                        ) : null}
                        {content?.imdbRate ? (
                          <div className="text-primary-white flex items-center gap-2">
                            <span className="ml-1">{content?.imdb_rate}</span>
                            <ImdbIcon />
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>
          <div className="relative left-2 bottom-[5px] z-10">
            <MediumLeftVector />
          </div>
        </div>
        <Swiper
          id="onlinebakhish-mobile"
          className="!flex xl:!hidden mx-auto w-[90%] xs:h-[145%] md:h-[130%] rounded-xl online-bakhish-mobile"
          modules={[Pagination, EffectCreative]}
          slidesPerView={1}
          autoplay={{ delay: 10000 }}
          spaceBetween={20}
          pagination={{ clickable: true }}
          effect={"creative"}
          loopAdditionalSlides={5}
          initialSlide={items?.length - 1}
          centerInsufficientSlides
          dir="ltr"
          creativeEffect={{
            prev: {
              shadow: true,
              translate: [0, -50, -400],
              scale: 0.95,
            },
            next: {
              translate: ["100%", 0, 0],
              scale: 0.95,
            },
          }}
        >
          {items?.map(({ content, sliderType }, index) => {
            const { contentPhotos, title, slug } = content;
            return (
              <SwiperSlide
                onClick={() => router.push(`/movie/${slug}`)}
                key={"sm_" + sliderType?.toString() + index?.toString()}
                className="!flex !justify-end bg-contain !items-center bg-black shadow-2xl rounded-2xl"
              >
                <div
                  dir="rtl"
                  className="flex w-full h-[192px] sm:h-[303px] md:h-[362px] lg:h-[460px] relative"
                  style={{
                    backgroundImage: `url(${getCMSImageURL(
                      contentPhotos.find(
                        (x) =>
                          x.type === "onlineBakhishCover" && device === device
                      )?.src ||
                        contentPhotos.find(
                          (x) => x.type === "onlineBakhishCover"
                        )?.src ||
                        contentPhotos.find(
                          (x) =>
                            x.type === "horizontalCover" && device === device
                        )?.src ||
                        contentPhotos.find((x) => x.type === "horizontalCover")
                          ?.src
                    )})`,
                    backgroundSize: "cover",
                    backgroundPosition: "left center",
                    backgroundRepeat: "no-repeat",
                    boxShadow: "inset 0px -35px 30px black",
                    aspectRatio: "16/9",
                    borderRadius: "30px",
                  }}
                >
                  <div className="flex justify-between w-full items-end px-0 md:px-5 lg:px-10 pb-0 md:pb-2 lg:pb-4 xl:pb-0">
                    <div className="pb-4 flex w-full justify-between px-8 items-center">
                      <span className="text-primary-white text-sm font-bold ml-6">
                        {title}
                      </span>
                      <CustomButton
                        label="سالن تماشا"
                        textColor="text-primary-white"
                        color="primary"
                        rightIcon={<TagIcon />}
                      />
                    </div>
                  </div>
                  <div
                    className="h-full w-full absolute top-0 left-0 rounded-xl"
                    style={{
                      backgroundImage:
                        "url(/onlineBakhish-vector-mobile-new.png)",
                      backgroundSize: "100% 100%",
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                    }}
                  ></div>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
      {/* <div className="w-full flex justify-center items-center h-28">
        <Link href={ROUTES.online_bakhish}>
          <Button variant="flat">
            <CiCirclePlus size={22} />
            مشاهده بیشتر
          </Button>
        </Link>
      </div> */}
    </div>
  );
};

export default OnlineBakhish;
